import * as React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

type Props = {
  description: string
}

export const BulkActionErrorSummary: React.FC<Props> = ({ description }) => (
  <Box mt={3}>
    <Typography
      gutterBottom
      style={{
        fontFamily: 'Source Sans Pro SemiBold',
      }}
    >
      Errors
    </Typography>
    <Typography paragraph>{description}</Typography>
  </Box>
)
BulkActionErrorSummary.displayName = 'BulkActionErrorSummary'
